export default "__VITE_ASSET__oZmMKfH8__"